import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export interface IAddImageIconProps extends IConDefaultType {}

function AddImageIcon({ color, className, size = 24, rotate = 0, flip }: IAddImageIconProps) {
  const fill = color || EColorMap.gray_0;

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(3.09 3)">
          <path
            d="M12.6 0H5.4C3.96783 0 2.59432 0.56893 1.58162 1.58163C0.568926 2.59432 0 3.96783 0 5.4V12.6C0 14.0322 0.568926 15.4057 1.58162 16.4184C2.59432 17.4311 3.96783 18 5.4 18H10.8C11.2971 18 11.7 17.5971 11.7 17.1C11.7 16.6029 11.2971 16.2 10.8 16.2H5.4C4.44522 16.2 3.52955 15.8207 2.85442 15.1456C2.17929 14.4705 1.8 13.5548 1.8 12.6V12.15L3.303 11.025C3.50449 10.8628 3.75536 10.7744 4.014 10.7744C4.27264 10.7744 4.52351 10.8628 4.725 11.025L6.894 12.825C7.35601 13.2096 7.93019 13.4341 8.53053 13.4649C8.65261 13.4712 8.74445 13.4764 8.81331 13.4806C8.87354 13.4933 8.93599 13.5 9 13.5C9.49706 13.5 9.9 13.0971 9.9 12.6C9.9 12.1029 9.49706 11.7 9 11.7C8.55 11.7 8.20937 11.5851 8.046 11.448L5.877 9.648C5.3648 9.2239 4.72441 8.98515 4.05959 8.97045C3.39476 8.95575 2.74444 9.16595 2.214 9.567L1.8 9.9V5.4C1.8 4.44522 2.17929 3.52954 2.85442 2.85441C3.52955 2.17928 4.44522 1.8 5.4 1.8H12.6C13.5548 1.8 14.4705 2.17928 15.1456 2.85441C15.8207 3.52954 16.2 4.44522 16.2 5.4V8.1C16.2 8.59706 16.6029 9 17.1 9C17.5971 9 18 8.59706 18 8.1V5.4C18 3.96783 17.4311 2.59432 16.4184 1.58163C15.4057 0.56893 14.0322 0 12.6 0Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.65901 8.34099C10.081 8.76295 10.6533 9 11.25 9C11.8467 9 12.419 8.76295 12.841 8.34099C13.2629 7.91904 13.5 7.34674 13.5 6.75C13.5 6.15326 13.2629 5.58097 12.841 5.15901C12.419 4.73705 11.8467 4.5 11.25 4.5C10.6533 4.5 10.081 4.73705 9.65901 5.15901C9.23705 5.58097 9 6.15326 9 6.75C9 7.34674 9.23705 7.91904 9.65901 8.34099ZM10.9318 6.4318C11.0162 6.34741 11.1307 6.3 11.25 6.3C11.3693 6.3 11.4838 6.34741 11.5682 6.4318C11.6526 6.51619 11.7 6.63065 11.7 6.75C11.7 6.86935 11.6526 6.98381 11.5682 7.0682C11.4838 7.15259 11.3693 7.2 11.25 7.2C11.1307 7.2 11.0162 7.15259 10.9318 7.0682C10.8474 6.98381 10.8 6.86935 10.8 6.75C10.8 6.63065 10.8474 6.51619 10.9318 6.4318Z"
            fill={fill}
          />
          <path
            d="M14.769 10.71C14.769 10.2626 15.1316 9.9 15.579 9.9H15.741C16.1884 9.9 16.551 10.2626 16.551 10.71V12.969H18.81C19.2574 12.969 19.62 13.3316 19.62 13.779V13.941C19.62 14.3884 19.2574 14.751 18.81 14.751H16.551V17.01C16.551 17.4574 16.1884 17.82 15.741 17.82H15.579C15.1316 17.82 14.769 17.4574 14.769 17.01V14.751H12.51C12.0626 14.751 11.7 14.3884 11.7 13.941V13.779C11.7 13.3316 12.0626 12.969 12.51 12.969H14.769V10.71Z"
            fill={fill}
          />
        </g>
      </svg>
    </i>
  );
}

export default AddImageIcon;
